import './ReleaseCard.css';  // Import the CSS for styling

interface ReleaseProps {
    version: number;
    storiesToAdd: number;
    sprintProgress: number; // release can only be done when sprint progress is 0
    releaseCallback: () => void;
}

export default function ReleaseCard(props: ReleaseProps) {
    return (
        <div className="scrum-card release-card">
            <div>
                <p><strong>Current version:</strong> {props.version.toFixed(1)}</p>
                <p><strong>Stories to add:</strong> {props.storiesToAdd}</p>
            </div>
            <button 
                className={'action-button'}
                style={{ 
                    backgroundColor: props.sprintProgress !== 0 || props.storiesToAdd === 0 ? 'gray' : '', 
                    cursor: props.sprintProgress !== 0 || props.storiesToAdd === 0 ? 'not-allowed' : '' 
                }}
                onClick={props.releaseCallback} 
                disabled={props.sprintProgress !== 0 || props.storiesToAdd === 0}><span style={{ marginRight: '8px' }}>🚀</span>Release</button>
        </div>
    );
}
